var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("table", { staticClass: "unstriped hover boss-table" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.jobs, function (job, i) {
          return _c("tr", { key: i, attrs: { "data-test": "jobs" } }, [
            _c(
              "td",
              {
                staticClass: "boss-table-data boss-calendar-jobs-body-id",
                attrs: { "data-test": "job-id" },
              },
              [_vm._v("\n          " + _vm._s(job.jobId) + "\n        ")]
            ),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass: "boss-table-data",
                attrs: { "data-test": "administration-name" },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(job.jobAdministrationName) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass: "boss-table-data left",
                attrs: { "data-test": "name" },
              },
              [_vm._v("\n          " + _vm._s(job.jobName) + "\n        ")]
            ),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass: "boss-table-data",
                attrs: { "data-test": "publishing-date" },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("formatDate")(job.startDate)) +
                    " ~ " +
                    _vm._s(_vm._f("formatDate")(job.endDate)) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass: "boss-table-data",
                class: {
                  "pega-empty-select required":
                    job.jobInterviewId == null && !job.isOriginalEntryForm,
                },
                attrs: { "data-test": "not-set-interview-class-" + i },
              },
              [
                job.isOriginalEntryForm
                  ? _c("div", [
                      _c(
                        "span",
                        { attrs: { "data-test": "original-entry-form-" + i } },
                        [
                          _vm._v("専用応募フォームを設定している求人は、"),
                          _c("br"),
                          _vm._v("面接情報を公開できません。"),
                        ]
                      ),
                    ])
                  : _c("div", [
                      job.jobInterviewId === null
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "boss-text boss-align-left pega-ml-1",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "boss-text boss-annotation-text",
                                  attrs: {
                                    "data-test": "not-set-interview-text-" + i,
                                  },
                                },
                                [_vm._v("※面接情報が公開されていません")]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: job.jobInterviewId,
                              expression: "job.jobInterviewId",
                            },
                          ],
                          staticClass:
                            "boss-input-select js-check-default pega-interview-pull-down",
                          attrs: { "data-test": "interview-pull-down-" + i },
                          on: {
                            change: [
                              function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  job,
                                  "jobInterviewId",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              function ($event) {
                                return _vm.updateInterview(
                                  job.jobId,
                                  job.jobInterviewId
                                )
                              },
                            ],
                          },
                        },
                        [
                          _vm._l(_vm.interviews, function (interview, j) {
                            return _c(
                              "option",
                              {
                                key: "interview-pull-down-" + i + "-" + j,
                                attrs: {
                                  "data-test":
                                    "interview-pull-down-option-" + i + "-" + j,
                                },
                                domProps: { value: interview.id },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(interview.name) +
                                    "\n              "
                                ),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c("option", { domProps: { value: null } }, [
                            _vm._v(
                              "\n                選択してください\n              "
                            ),
                          ]),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "boss-text boss-align-left pega-ml-1" },
                        [
                          job.jobInterviewId == null
                            ? _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "interviewInformationRegister",
                                    },
                                    "data-test": "registration-interview-" + i,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                新規登録する\n              "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
              ]
            ),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", { attrs: { "data-test": "jobs-title" } }, [
        _c("th", { staticClass: "boss-table-head-center text-nowrap" }, [
          _vm._v("\n          求人ID\n        "),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "boss-table-head-center text-nowrap" }, [
          _vm._v("\n          管理用求人名\n        "),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "boss-table-head-center text-nowrap" }, [
          _vm._v("\n          求人名\n        "),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "boss-table-head-center text-nowrap" }, [
          _vm._v("\n          掲載期間\n        "),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "boss-table-head-center text-nowrap" }, [
          _vm._v("\n          公開する面接情報\n        "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }